export default __webpack_public_path__ + "static/media/correct21.7fc76129.mp3";